export default __webpack_public_path__ + "static/media/Afacad-Regular.a870c30f.ttf";